<template>
    <vx-card slot="no-body" class="border-2 shadow-none border-solid border-1  md:w-2/3 lg:w-full" cardBackground="">

      <div class="ml-4">
<!--         <div class="flex items-start">
          <feather-icon icon="CheckIcon" class="w-4 mr-2"/>
          <p>Accomplish <span class="font-semibold">Financial freedom</span></p>
        </div> -->
        <div class="flex items-start">
          <feather-icon icon="CheckIcon" class="w-4 mr-2"/>
          <p>goal setting & daily planner</p>
        </div>
        <div class="flex items-start">
          <feather-icon icon="CheckIcon" class="w-4 mr-2"/>
          <p>habit and routine builder</p>
        </div>
        <div class="flex items-start">
          <feather-icon icon="CheckIcon" class="w-4 mr-2"/>
          <p>AI coach & personal plan</p>
        </div>
       <div class="flex items-start">
          <feather-icon icon="CheckIcon" class="w-4 mr-2"/>
          <p>guided journal & reflection</p>
        </div>

        <div class="flex items-start">
          <feather-icon icon="CheckIcon" class="w-4 mr-2"/>
          <p>real-time progress tracking</p>
        </div>
      </div>
    </vx-card>
</template>

<script>
export default {
  data() {
    return {
      // Component data here
    }
  },
  methods: {
    // Component methods here
  },
  computed: {
    // Computed properties here
  },
  mounted() {
    // Code that runs when the component is mounted to the DOM
  }
}
</script>
